module.exports = __webpack_public_path__ + "static/media/kemit.e776e400.svg";